function toWebkitOrNot() {
    if (typeof data.style.transform === 'string') {
        return 'transform';
    }
    return 'WebkitTransform';
}

function roundUp(num, precision) {
    return Math.ceil(num * precision) / precision
}

function roundDown(num, precision) {
    return Math.floor(num * precision) / precision
}

// https://stackoverflow.com/questions/16994662/count-animation-from-number-a-to-b
function animateValue(obj, start, end, duration) {
    var range = end - start;
    // no timer shorter than 50ms (not really visible any way)
    var minTimer = 50;
    // calc step time to show all interediate values
    var stepTime = Math.abs(Math.floor(duration / range));

    // never go below minTimer
    stepTime = Math.max(stepTime, minTimer);

    // get current time and calculate desired end time
    var startTime = new Date().getTime();
    var endTime = startTime + duration;
    var timer;

    function run() {
        var now = new Date().getTime();
        var remaining = Math.max((endTime - now) / duration, 0);
        var value = Math.round(end - (remaining * range));
        obj.innerHTML = value + '%';
        if (value == end) {
            clearInterval(timer);
        }
    }

    timer = setInterval(run, stepTime);
    run();
}

/*
 * Take a number and convert to a currency format for display
 *
 * @param {number} Number for converstion
 * @return {string} The number presented as a currency string
 */
function toCurrency(value) {
    value = Math.floor(value);
    var value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return '£' + value;
}

function updateTotaliser(progressNumber, goalNumber) {
    // Find the totaliser
    var totaliser = document.querySelector('.totaliser');
    // Get the bar in the totaliser
    var totaliserBar = totaliser.querySelector('.totaliser-amount');

    // Work out the progress in percent
    var percentComplete = (progressNumber / goalNumber) * 100;

    // Detect css support
    var transformProperty = toWebkitOrNot();

    // Get the element to animate
    var totalPercentElement = totaliser.querySelector('.totaliser-amount-percent');

    // Animate the bar to the progress
    totaliserBar.style[transformProperty] = "translate3d(" + percentComplete + "%, 0, 0)";

    // Get the percentage amount to display on the bar
    var displayValue = roundDown( percentComplete, 1);

    // Animate the progress bar
    animateValue(totalPercentElement, 0, displayValue , 1500);

    // Get the formatted output for the donation amount in plain text
    var formattedRaisedElement = document.querySelector('.js-raised-formatted');
    var formattedTargetElement = document.querySelector('.js-target-formatted');
    
    // Convert numbers to currency amounts
    var formattedRaised = toCurrency(progressNumber);
    var formattedTarget = toCurrency(goalNumber);

    // Display the currency amounts
    formattedRaisedElement.innerHTML = formattedRaised;
    formattedTargetElement.innerHTML = formattedTarget;
}

var data = document.querySelector('.js-totaliser');

if (data) {
    // Get data from civi as saved in the form template
    var targetAmount = data.getAttribute('data-totaliser-target');
    var currentAmount = data.getAttribute('data-totaliser-raised');

    // On load animate in the totaliser
    window.onload = updateTotaliser(currentAmount, targetAmount);
}

